import React from 'react';
import { motion } from 'framer-motion';
import { Clock, MapPin, Phone, Map } from 'lucide-react';
export const ScheduleLocation = () => {
  return <section id="horarios" className="py-20 md:py-32 bg-gradient-to-b from-brand-bg to-pink-50" data-id="element-136">
      <div className="max-w-6xl mx-auto px-6" data-id="element-137">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-138">
          {/* Schedule Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl shadow-brand-pink/5 border border-white" data-id="element-139">
            <div className="w-12 h-12 rounded-full bg-brand-bg flex items-center justify-center mb-6" data-id="element-140">
              <Clock className="text-brand-magenta" size={24} data-id="element-141" />
            </div>
            <h3 className="text-3xl font-heading font-bold text-brand-dark mb-8" data-id="element-142">
              Horarios de Atención
            </h3>

            <ul className="space-y-6" data-id="element-143">
              <li className="flex items-start gap-4" data-id="element-144">
                <div className="mt-1 text-brand-pink" data-id="element-145">
                  <Clock size={18} data-id="element-146" />
                </div>
                <div data-id="element-147">
                  <p className="font-bold text-brand-dark" data-id="element-148">Lunes</p>
                  <p className="text-brand-dark/70" data-id="element-149">12:00 – 20:00 hs</p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-150">
                <div className="mt-1 text-brand-pink" data-id="element-151">
                  <Clock size={18} data-id="element-152" />
                </div>
                <div data-id="element-153">
                  <p className="font-bold text-brand-dark" data-id="element-154">Martes a Viernes</p>
                  <p className="text-brand-dark/70" data-id="element-155">10:00 – 20:00 hs</p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-156">
                <div className="mt-1 text-brand-pink" data-id="element-157">
                  <Clock size={18} data-id="element-158" />
                </div>
                <div data-id="element-159">
                  <p className="font-bold text-brand-dark" data-id="element-160">Sábado</p>
                  <p className="text-brand-dark/70" data-id="element-161">10:00 – 18:00 hs</p>
                </div>
              </li>
            </ul>
          </motion.div>

          {/* Location Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl shadow-brand-pink/5 border border-white flex flex-col" data-id="element-162">
            <div className="w-12 h-12 rounded-full bg-brand-bg flex items-center justify-center mb-6" data-id="element-163">
              <MapPin className="text-brand-magenta" size={24} data-id="element-164" />
            </div>
            <h3 className="text-3xl font-heading font-bold text-brand-dark mb-8" data-id="element-165">
              Encontranos
            </h3>

            <div className="space-y-6 mb-8 flex-grow" data-id="element-166">
              <div className="flex items-start gap-4" data-id="element-167">
                <div className="mt-1 text-brand-pink" data-id="element-168">
                  <MapPin size={18} data-id="element-169" />
                </div>
                <div data-id="element-170">
                  <p className="font-bold text-brand-dark" data-id="element-171">Dirección</p>
                  <p className="text-brand-dark/70" data-id="element-172">
                    26 de Marzo 3420, Montevideo
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-173">
                <div className="mt-1 text-brand-pink" data-id="element-174">
                  <Phone size={18} data-id="element-175" />
                </div>
                <div data-id="element-176">
                  <p className="font-bold text-brand-dark" data-id="element-177">WhatsApp</p>
                  <p className="text-brand-dark/70" data-id="element-178">092 200 000</p>
                </div>
              </div>
            </div>

            {/* Map Placeholder */}
            <div className="w-full h-48 bg-gray-100 rounded-2xl border border-gray-200 flex flex-col items-center justify-center text-gray-400 relative overflow-hidden group cursor-pointer" data-id="element-179">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=800&auto=format&fit=crop')] bg-cover bg-center opacity-40 group-hover:opacity-50 transition-opacity" data-id="element-180"></div>
              <div className="absolute inset-0 bg-brand-pink/10" data-id="element-181"></div>
              <Map size={32} className="mb-2 relative z-10 text-brand-magenta" data-id="element-182" />
              <span className="font-medium relative z-10 text-brand-dark" data-id="element-183">
                Ver en Google Maps
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};